var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "info_config_page" },
    [
      _c(
        "div",
        { staticClass: "common_form_search" },
        [
          _c(
            "el-form",
            {
              ref: "searchForm",
              attrs: { inline: true, model: _vm.searchForm }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "品类名称" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入品类名称", clearable: "" },
                    model: {
                      value: _vm.searchForm.name,
                      callback: function($$v) {
                        _vm.$set(_vm.searchForm, "name", $$v)
                      },
                      expression: "searchForm.name"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "字段类型" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "全部", clearable: "" },
                      model: {
                        value: _vm.searchForm.field_type,
                        callback: function($$v) {
                          _vm.$set(_vm.searchForm, "field_type", $$v)
                        },
                        expression: "searchForm.field_type"
                      }
                    },
                    [
                      _c("el-option", { attrs: { label: "文本框", value: 1 } }),
                      _c("el-option", { attrs: { label: "单选", value: 2 } }),
                      _c("el-option", { attrs: { label: "多选", value: 3 } })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.search()
                        }
                      }
                    },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: {
                        click: function($event) {
                          return _vm.reset()
                        }
                      }
                    },
                    [_vm._v("重置")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("el-divider"),
      _c(
        "div",
        { staticClass: "flex align-center table-top-btns" },
        [
          _c(
            "h5",
            { staticClass: "flex align-center" },
            [
              _c("svg-icon", {
                staticStyle: { "margin-right": "15px" },
                attrs: { "icon-class": "list", size: 15 }
              }),
              _vm._v("数据列表\n    ")
            ],
            1
          ),
          _vm.$hasMethod("#add")
            ? _c(
                "el-button",
                {
                  staticClass: "add-btn",
                  attrs: { size: "small", icon: "el-icon-plus" },
                  on: { click: _vm.addSources }
                },
                [_vm._v("添加表单项")]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-table",
        { attrs: { data: _vm.tableData, border: "" } },
        [
          _c("el-table-column", {
            attrs: { align: "center", label: "ID", prop: "id", width: "100" }
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "品类名称", prop: "name" }
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "字段排序",
              prop: "field_order",
              width: "100"
            }
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "字段描述", prop: "field_title" }
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "字段类型", prop: "field_type" }
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "字段值",
              prop: "field_val",
              width: "260"
            }
          }),
          _c("el-table-column", {
            attrs: { label: "必填项", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: scope.row.must_is == "否" ? "danger" : "success"
                        }
                      },
                      [_vm._v(_vm._s(scope.row.must_is == "否" ? "否" : "是"))]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              width: "100",
              label: "创建时间",
              prop: "create_time"
            }
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "操作", fixed: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm.$hasMethod("#edit")
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.editItem(scope.row)
                              }
                            }
                          },
                          [_vm._v("编辑")]
                        )
                      : _vm._e(),
                    _vm.$hasMethod("#delete")
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "danger" },
                            on: {
                              click: function($event) {
                                return _vm.deleteItem(scope.row.id)
                              }
                            }
                          },
                          [_vm._v("删除")]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("custom-page", {
        ref: "customPage",
        attrs: { total: _vm.total },
        on: { getList: _vm.getList }
      }),
      _c("add-custom", {
        ref: "saveTagInput",
        attrs: {
          handleDialog: _vm.handleDialog,
          dialogTitle: _vm.dialogTitle,
          isEdit: _vm.isEdit,
          customForm: _vm.customForm,
          cateList: _vm.cateList,
          tagsList: _vm.tagsList,
          isInputVisible: _vm.inputVisible
        },
        on: {
          submitForm: _vm.submitForm,
          closeDialog: _vm.closeDialog,
          closeTag: _vm.closeTag,
          showInput: _vm.showInput,
          changeCascader: _vm.changeCascader,
          tagInputConfirm: _vm.tagInputConfirm
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }